export interface LinkSelection {
  type: SelectionType;
  link: SelectedLink;
}

export const enum SelectionType {
  linkSelected,
  textSelected,
}

export interface SelectedLink {
  attributes: LinkAttributes;
  element: HTMLAnchorElement;
}

export interface LinkAttributes {
  title: string;
  href: string;
}
